import TabletopCanvasMouseEvent from "../events/TabletopCanvasMouseEvent";
import TabletopCanvasNavigationController from "./TabletopCanvasNavigationController";
import TabletopCharacterToken from "../../objects/token/TabletopCharacterToken";
import TabletopUniverse from "../../objects/TabletopUniverse";
import TabletopViewport from "../../objects/TabletopViewport";

import portraitN from "../../../../assets/images/common/svg/portrait_n.svg";
import portraitF from "../../../../assets/images/common/svg/portrait_f.svg";
import portraitM from "../../../../assets/images/common/svg/portrait_m.svg";
import { Point2d } from "../../../../common/geometry/Geom2d";

export default class TabletopCanvasCreateTokenController extends TabletopCanvasNavigationController {
    public constructor(viewport: TabletopViewport, universe: TabletopUniverse) {
        super(viewport, universe);
    }

    public override dispose(): void {
        super.dispose();
    }

    private createTokenAt(position: Point2d): void {
        const r = Math.floor(Math.random() * 3);
        const portrait = r === 0 ? portraitN : r === 1 ? portraitF : portraitM;

        const newToken = new TabletopCharacterToken({
            x: position.x,
            y: position.y,
            width: this._universe.defaultTokenSize,
            height: this._universe.defaultTokenSize,
            imgSrc: portrait,
        });

        const characterID = Math.floor(Math.random() * 6);

        if (this._universe.characterBank.hasCharacter(characterID)) {
            newToken.characterData =
                this._universe.characterBank.getCharacter(characterID);
        } else {
            this._universe.characterBank.loadCharacter(
                characterID,
                (characterData) => {
                    newToken.characterData = characterData;
                },
            );
        }

        this._universe.addElement(newToken);
    }

    public override onCanvasMouseDrag(e: TabletopCanvasMouseEvent): void {
        if (e.altKey) {
            super.onCanvasMouseDrag(e);
        }
    }

    public override onCanvasMouseDown(e: TabletopCanvasMouseEvent): void {
        if (e.altKey) {
            super.onCanvasMouseDown(e);
            return;
        }

        const gridCoordinate =
            this._universe.gridElement?.getCellCoordinatesFromUniversePoint(
                e.universePosition,
            );

        if (gridCoordinate == null) {
            return;
        }

        const tokenExists =
            this._universe.getTokensAtGridCoordinate(gridCoordinate).length > 0;

        if (!tokenExists) {
            const position =
                this._universe.gridElement?.snapUniversePointToGrid(
                    e.universePosition,
                ) ?? e.universePosition;
            this.createTokenAt(position);
        }
    }
}
